module.exports = __webpack_public_path__ + "static/media/Randy_Cole_Design_resume.3db431a3.pdf";